<div class="seccion-media">
  <h2>Extras</h2>
</div>
<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>
<div class="seccion-media">
  <div class="prensa">
    <mat-card class="nota" *ngFor="let extra of extras">
      <a [href]="extra.url">
        <h3>{{ extra.title }}</h3>
        <span>{{ extra.date | date:'yyyy' }}</span>
      </a>
    </mat-card>
  </div>
</div>
